import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter
} from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-KG2JBTD'
}

TagManager.initialize(tagManagerArgs)

const container = document.getElementById("app");
if (!container) throw new Error('Failed to find the app element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
